import { Search, X } from 'lucide-react';
import styles from './SearchInput.module.css';

function SearchInput({ value, onChange, placeholder = 'Search', className = '' }) {
  // Callers all read `e.target.value`, so a plain object stands in for the
  // change event the input would have fired.
  const clear = () => onChange({ target: { value: '' } });

  return (
    <div className={`${styles.wrapper} ${className}`}>
      <Search size={20} className={styles.icon} />
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={styles.input}
      />
      {value && (
        <button
          type="button"
          className={styles.clearBtn}
          onClick={clear}
          aria-label="Clear search"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}

export default SearchInput;
